/** Cookie/analytics consent.
 *
 *  Enforcement is a hard block: gtag.js is NOT in index.html and is only injected after the
 *  visitor opts in. Consent Mode v2 defaults (all denied) are set in index.html, so when the
 *  script does load it already knows the answer. Only the strictly-necessary session cookie
 *  runs without consent.
 */
import api from "@/lib/api";

const KEY = "so_cookie_consent";
export const POLICY_VERSION = "2026-08-13";
export const OPEN_PREFS_EVENT = "so:open-cookie-preferences";

export const readConsent = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "null");
    return raw && raw.version === POLICY_VERSION ? raw : null;
  } catch {
    return null;
  }
};

let loaded = false;

/** Inject gtag.js and flip Consent Mode to granted. Safe to call more than once. */
export const enableAnalytics = () => {
  const id = window.__SO_GA_ID;
  if (!id) return;
  if (typeof window.gtag !== "function") {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
  }
  window.gtag("consent", "update", { analytics_storage: "granted" });
  if (loaded) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.gtag("config", id);
};

const disableAnalytics = () => {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: "denied" });
  }
};

export const saveConsent = (analytics) => {
  const record = { analytics: !!analytics, version: POLICY_VERSION, decided_at: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(record)); } catch { /* private mode */ }
  if (analytics) enableAnalytics(); else disableAnalytics();
  api.post("/consent/cookies", { analytics: !!analytics, policy_version: POLICY_VERSION }).catch(() => {});
  return record;
};

/** Re-apply a stored decision on every page load. */
export const applyStoredConsent = () => {
  const stored = readConsent();
  if (stored?.analytics) enableAnalytics();
  return stored;
};

export const openCookiePreferences = () => window.dispatchEvent(new Event(OPEN_PREFS_EVENT));
